import { getDictionary } from '@synisys/dictionary';
import { parseInt } from 'lodash-es';
import { assertMonth, localDateFromUTCDate, normalizeLocalDate, } from '../shared/date-types';
import { JS_THURSDAY } from '../shared/utils';
/**
 * converts date to {year}/{week} format
 * @param year year e.g. 1984
 * @param week week indexed
 */
export function weekToKey(year, week) {
    return `${year}/${week}`;
}
/**
 * inverse of weekToKey
 * @param key should be in {year}/{week} format
 */
export function keyToWeek(key) {
    const [year, week] = key.split('/');
    const yearParsed = parseInt(year);
    const weekParsed = assertWeek(parseInt(week));
    return [yearParsed, weekParsed];
}
const DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;
export function getDayOfYear(date) {
    const theDate = Date.UTC(date[0], date[1] - 1, date[2]);
    const start = Date.UTC(date[0], 0, 0);
    const diff = theDate - start;
    return diff / DAY_IN_MILLISECONDS;
}
function getFirstThursdayOfYear(year) {
    let firstThursdayOfYear = 1;
    while (new Date(Date.UTC(year, 0, firstThursdayOfYear)).getUTCDay() !== JS_THURSDAY) {
        firstThursdayOfYear++;
    }
    return firstThursdayOfYear;
}
function getClosestThursdayOfYear(date) {
    const theDate = new Date(Date.UTC(date[0], date[1] - 1, date[2]));
    const weekDay = jsWeekDayToMondayWeek(theDate.getUTCDay());
    theDate.setUTCDate(theDate.getUTCDate() - weekDay + jsWeekDayToMondayWeek(JS_THURSDAY));
    return localDateFromUTCDate(theDate);
}
/** WeekDay index, Monday is 0, Tuesday is 1, so on */
function jsWeekDayToMondayWeek(day) {
    return (day + 6) % 7;
}
/** Week Number is a number of Thursdays in that year before given date's closest Thursdays */
export function localDateToLocalWeek(date) {
    let firstThursdayOfYear = getFirstThursdayOfYear(date[0]);
    const closestThursday = getClosestThursdayOfYear(date);
    if (closestThursday[0] !== date[0]) {
        firstThursdayOfYear = getFirstThursdayOfYear(closestThursday[0]);
    }
    const closestThursdayDayOfYear = getDayOfYear(closestThursday);
    return [
        closestThursday[0],
        assertWeek((closestThursdayDayOfYear - firstThursdayOfYear) / 7 + 1),
    ];
}
export function weekToDays(week) {
    const firstThursdayOfYear = getFirstThursdayOfYear(week[0]);
    const thursdayOfTheWeek = firstThursdayOfYear + (week[1] - 1) * 7;
    return [-3, -2, -1, 0, 1, 2, 3].map(diff => normalizeLocalDate([week[0], 1, thursdayOfTheWeek + diff]));
}
export function assertWeek(week) {
    if (week <= 0 || 53 < week) {
        console.error('week value is wrong:', week);
    }
    return week;
}
export function monthWithMostDaysInWeek(week) {
    const monthWithSizes = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    week.forEach(w => {
        monthWithSizes[w[1] - 1] = (monthWithSizes[w[1] - 1] || 0) + 1;
    });
    return assertMonth(monthWithSizes.indexOf(Math.max(...monthWithSizes)) + 1);
}
export function displayWeekDate(localWeek, locale = 'en') {
    const [year, week] = localWeek;
    const intlPluralRules = new Intl.PluralRules(locale, {
        type: 'ordinal',
    });
    return year.toString() + '-' + week.toString() + getOrdinalSuffix(intlPluralRules.select(week));
}
/// TODO: when requirements for suffix will be clear, we will use language_plural_rules
/// https://unicode-org.github.io/cldr-staging/charts/latest/supplemental/language_plural_rules.html
const ordinal_suffixes_en = new Map([
    ['one', 'st'],
    ['two', 'nd'],
    ['few', 'rd'],
    ['other', 'th'],
]);
function getOrdinalSuffix(ordinal) {
    // TODO: remove this when requirements for suffix will be clear
    const key = `ordinal_suffixes_${ordinal}`;
    const translation = getDictionary().translate(key);
    return key === translation ? ordinal_suffixes_en.get(ordinal) || '' : translation;
}
export function normalizeLocalWeek(year, week) {
    const firstThursdayOfYear = getFirstThursdayOfYear(year);
    const thursdayOfTheWeek = firstThursdayOfYear + (week - 1) * 7;
    const date = normalizeLocalDate([year, 1, thursdayOfTheWeek]);
    return localDateToLocalWeek(date);
}
